import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { ChatInfo } from "./types";
import { useEffect, useState } from "react";
import { sendServerRequest } from "../../server/request";
import { URLS } from "../../env/urls";
import { CircularLoading } from "../utils/loading";
import { LoadingButton } from "@mui/lab";
import { openGlobalSnack } from "../utils/snack";
import { PixField } from "../utils/pix/field";
import { formatCPF } from "../../utils/formatcpf";
import { checkPix, normalizePix, pixToPixType } from "../utils/pix/pixfunctions";
import { PropostalInfoComplete } from "../types/propostals";
import { SelectFromItems } from "../utils/forms/select";
import { DocForm, DocFormComplete } from "./uploaddoc";

export function PendencyButton({chat,senderPhone}:{chat:ChatInfo,senderPhone:string}){
     const [open,setOpen]=useState(false);
     return (
        <>
            <Button sx={{margin:'auto'}} onClick={()=>{setOpen(true)}}variant="contained">Pendências</Button>
            <PendencyDialog senderPhone={senderPhone} chat={chat} close={()=>setOpen(false)} open={open}/>
        </>
     )
}

export function PendencyDialog({chat,open,senderPhone,close}:{chat:ChatInfo,senderPhone:string,open:boolean,close:()=>any}){
      const [pendency,setPendency]=useState<any>(false);
      const [loadingPendency,setLoadingPendency]=useState(false);
      const [resolving,setResolving]=useState(false);
      useEffect(()=>{
           if(open&&!loadingPendency){
               setLoadingPendency(true);
           }
      },[open]);
      useEffect(()=>{
         if(loadingPendency){
            sendServerRequest('POST',`${URLS.solve.hasPendency}/${chat.clientId}`).then(e=>{
                const data=e.data.data;
                setPendency({
                    data,
                    needUp:!data.hasRG&&!data.hasCLT&&!data.hasCNH,

                });
                setLoadingPendency(false);
            }).catch(e=>{
                setLoadingPendency(false);
                
            });
         }
      },[loadingPendency]);
      useEffect(()=>{
        if(resolving){
           sendServerRequest('POST',`${URLS.solve.resolve}/${chat.clientId}`,{senderPhone:senderPhone}).then(e=>{
               openGlobalSnack('Pendência resolvida','success');
               close();
               setResolving(false);
           }).catch(e=>{
               console.log(e);
               openGlobalSnack('Erro ao resolver pendência','error');
               setResolving(false);
               
           });
        }
     },[resolving]);
      
    
      return (
          <Dialog open={open}>
              <DialogTitle>{`Pendências: ${chat.name} ${chat.info}`}</DialogTitle>
              <DialogContent>
                  {loadingPendency?<CircularLoading/>:<>
                     {pendency?<div>
                         {pendency.needUp?<p>Precisa adiconar um documento</p>:
                         <LoadingButton loading={resolving} onClick={()=>setResolving(true)} fullWidth variant="contained">Resolver Pendência</LoadingButton>}
                     </div>:<div>
                          Sem pendências.
                        </div>}
                  </>}
              </DialogContent>
              <DialogActions>
                <Button disabled={resolving} onClick={()=>{close()}}>Fechar</Button>
              </DialogActions>
          </Dialog>
      )
}

export function PendencyForm({propostal,cpf,onResolve}:{propostal:PropostalInfoComplete,cpf:string,onResolve:Function}){

    const [loadingPix,setLoadingPix]=useState(false);
    const [pixType,setPixType]=useState<undefined|string>();
    const [pixKey,setPixKey]=useState<undefined|string>();
    const [sendingForm,setSendingForm]=useState<undefined|FormData>()
    useEffect(()=>{
      if(loadingPix){
         sendServerRequest('POST',`${URLS.propostals.resolvePix}/${propostal.id}`,pixKey?{
            pixType:pixToPixType(pixType as string),
            pix:normalizePix(pixType||'',pixKey),
         }:undefined).then(e=>{
             openGlobalSnack('Pendência resolvida','success');
             setLoadingPix(false);
             onResolve();
         }).catch(e=>{
             console.log(e);
             openGlobalSnack('Erro ao resolver pendência','error');
             setLoadingPix(false);
             
         });
      }
    },[loadingPix]);
    useEffect(()=>{
       if(!sendingForm)return;
       sendServerRequest("POST",`${URLS.propostals.resolveDocument}/${propostal.id}`,sendingForm).then(e=>{
                   setSendingForm(undefined);
                   openGlobalSnack('Pendência resolvida','success');
                   onResolve();
              }).catch(e=>{
                   setSendingForm(undefined);
                   openGlobalSnack('Erro ao fazer upload dos arquivos','error');
              })
    },[sendingForm])
  
    return (
        <div>
            <p>{`CPF: ${formatCPF(cpf)}`}</p>
            {propostal.statusReason?<p>{propostal.statusReason}</p>:null}
            {propostal.statusDescription?<p>{propostal.statusDescription}</p>:null}
            {propostal.statusReason&&propostal.statusReason.indexOf('pix')>-1?<div style={{marginTop:'15px',textAlign:'center'}}>
                <p>Atualize o pix do cliente.</p>
                <PixField disabled={loadingPix} onUpdate={(t,p)=>{
                      setPixType(t);
                      setPixKey(p);
                }} uniqueCpf={cpf}/>
                <LoadingButton disabled={!checkPix(pixType||'',pixKey||'')} onClick={()=>setLoadingPix(true)} loading={loadingPix} variant="contained">Atualizar Pix</LoadingButton>
            </div>:<div>
                
               <DocFormComplete loading={Boolean(sendingForm)} onSendForm={setSendingForm}/>
            </div>}
        
        </div>
    )
}

